<template>
  <div class="tw:flex tw:flex-col tw:gap-y-4">
    <div class="tw:flex tw:flex-col tw:gap-y-1">
      <ul class="tw:flex tw:flex-col tw:gap-y-1">
        <li class="tw:text-sm tw:flex tw:items-start" v-for="(point, pointIndex) in points" :key="pointIndex">
          <span class="tw:text-red-700 tw:mr-1 tw:w-2">{{ '- ' }}</span>
          <span>{{ $t(point) }}</span>
        </li>
      </ul>
    </div>
    <div class="tw:flex tw:flex-row tw:gap-x-2">
      <div class="tw:flex tw:flex-col tw:gap-y-1 tw:w-1/3" data-testid="image-not-permitted-people">
        <img :src="PeopleImage" :alt="$t('image_not_permitted_1')" class="tw:rounded-md" />
        <p class="tw:text-xs tw:text-gray-700">{{ $t('image_not_permitted_1') }}</p>
      </div>
      <div class="tw:flex tw:flex-col tw:gap-y-1 tw:w-1/3">
        <img
          :src="LogosImage"
          :alt="$t('image_not_permitted_2')"
          class="tw:rounded-md"
          data-testid="image-not-permitted-logos"
        />
        <p class="tw:text-xs tw:text-gray-700">{{ $t('image_not_permitted_2') }}</p>
      </div>
      <div class="tw:flex tw:flex-col tw:gap-y-1 tw:w-1/3">
        <img
          :src="HeavilyEditedImage"
          :alt="$t('image_not_permitted_3')"
          class="tw:rounded-md"
          data-testid="image-not-permitted-editing"
        />
        <p class="tw:text-xs tw:text-gray-700">{{ $t('image_not_permitted_3') }}</p>
      </div>
    </div>
    <div class="tw:flex tw:flex-row tw:gap-x-2">
      <div class="tw:flex tw:flex-col tw:gap-y-1 tw:w-1/3" data-testid="image-not-permitted-blurry">
        <img :src="BlurryImage" :alt="$t('image_not_permitted_4')" class="tw:rounded-md" />
        <p class="tw:text-xs tw:text-gray-700">{{ $t('image_not_permitted_4') }}</p>
      </div>
      <div class="tw:flex tw:flex-col tw:gap-y-1 tw:w-1/3" data-testid="image-not-permitted-qr">
        <img :src="NoQRCodesImage" :alt="$t('image_not_permitted_5')" class="tw:rounded-md" />
        <p class="tw:text-xs tw:text-gray-700">{{ $t('image_not_permitted_5') }}</p>
      </div>
      <div class="tw:flex tw:flex-col tw:gap-y-1 tw:w-1/3" data-testid="image-not-permitted-contact">
        <img :src="NoContactDetailsImage" :alt="$t('image_not_permitted_6')" class="tw:rounded-md" />
        <p class="tw:text-xs tw:text-gray-700">{{ $t('image_not_permitted_6') }}</p>
      </div>
    </div>
  </div>
</template>
<script setup>
const PeopleImage = new URL(`../../../assets/img/property-details/property-images/no_people.png`, import.meta.url)
const LogosImage = new URL(`../../../assets/img/property-details/property-images/logos.png`, import.meta.url)
const HeavilyEditedImage = new URL(
  `../../../assets/img/property-details/property-images/heavily_edited.png`,
  import.meta.url
)
const BlurryImage = new URL(`../../../assets/img/property-details/property-images/blurry.png`, import.meta.url)
const NoQRCodesImage = new URL(`../../../assets/img/property-details/property-images/no_qr_codes.png`, import.meta.url)
const NoContactDetailsImage = new URL(
  `../../../assets/img/property-details/property-images/no_contact_details.png`,
  import.meta.url
)

const points = [
  'tbs_images_not_permitted_1',
  'tbs_images_not_permitted_2',
  'tbs_images_not_permitted_3',
  'tbs_images_not_permitted_4',
  'tbs_images_not_permitted_5',
]
</script>
